import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';

@Directive({
  selector: 'input[payee-input], textarea[payee-input]',
  exportAs: 'payeeInput',
})
export class PayeeInputDirective implements OnInit {
  private ref = inject<ElementRef<HTMLElement>>(ElementRef);
  private controlContainer = inject(ControlContainer, {
    optional: true,
    host: true,
    skipSelf: true,
  });

  @Input() formControl?: FormControl<unknown>;
  @Input() formControlName?: string;

  readonly element: HTMLElement;

  constructor() {
    this.element = this.ref.nativeElement;
  }

  ngOnInit(): void {
    if (this.controlContainer) {
      if (this.formControlName) {
        const control = this.controlContainer.control?.get(
          this.formControlName,
        );
        if (control) {
          this.formControl = control as FormControl<unknown>;
        }
      }
    }
  }
}
